import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
//controls
import {
  Input,
  Col,
  Label,
  Row,
  Modal,
  ModalBody,
  FormFeedback,
  ModalHeader,
  ModalFooter,
} from "reactstrap"
import Flatpickr from "react-flatpickr"

//react form
import { FormProvider, useForm, Controller } from "react-hook-form"

//validation
import * as yup from "yup"
import { yupResolver } from "@hookform/resolvers/yup"

//redux
import { useSelector, useDispatch } from "react-redux"

//custom hooks
import { useDeepCompareEffect } from "hooks"

import {
  updateProfileClosing as onUpdateProfileClosing,
  deleteProfileClosing as onDeleteProfileClosing,
} from "store/actions"
import DeleteModal from "components/Common/DeleteModal"

const ClosingModal = ({ profileID, data, onEdit, show, onCloseClick }) => {
  const dispatch = useDispatch()
  const [deleteModal, setDeleteModal] = useState(false)
  const [centerClosingID, setCenterClosingID] = useState(0)

  /**
   * Form Validation Schema
   */
  const schema = yup.object().shape({
    CenterClosingID: yup.number(),
    CenterProfileID: yup.number(),
    ClosingDate: yup.string().required("Required"),
    Description: yup.string().required("Required"),
  })

  const formdefault = {
    CenterClosingID: 0,
    CenterProfileID: profileID,
    ClosingDate: "",
    Description: "",
  }

  const methods = useForm({
    mode: "onChange",
    defaultValues: formdefault,
    resolver: yupResolver(schema),
  })
  const { reset, control, formState, setValue, getValues, trigger } = methods
  const { errors, isValid } = formState

  useDeepCompareEffect(() => {
    function updateState() {
      if (show) {
        if (onEdit) {
          reset(data)
        } else {
          reset(formdefault)
        }
      }
    }

    updateState()
  }, [show, dispatch])

  const onSaveClick = () => {
    trigger()
    if (isValid) {
      dispatch(onUpdateProfileClosing(getValues()))
      onCloseClick()
    }
  }

  const onDeleteClick = () => {
    setCenterClosingID(data.CenterClosingID)
    setDeleteModal(true)
  }

  const handleDelete = () => {
    if (centerClosingID) {
      dispatch(onDeleteProfileClosing(centerClosingID))
      setDeleteModal(false)
      onCloseClick()
    }
  }

  const onClosed = () => {
    reset()
  }

  return (
    <>
      {deleteModal && (
        <DeleteModal
          show={deleteModal}
          onDeleteClick={handleDelete}
          onCloseClick={() => setDeleteModal(false)}
        />
      )}
      <Modal
        isOpen={show}
        toggle={onCloseClick}
        onClosed={() => onClosed()}
        centered={true}
      >
        <ModalHeader className="d-flex justify-content-center">
          Add Closed Day
        </ModalHeader>
        <ModalBody className="py-3 px-5">
          <FormProvider {...methods}>
            <Row>
              <Col lg={12}>
                <div className="mb-3">
                  <Label>Date</Label>
                  <Controller
                    name="ClosingDate"
                    control={control}
                    render={({ field }) => (
                      <>
                        <Flatpickr
                          {...field}
                          className="form-control d-block"
                          id="ClosingDate"
                          options={{
                            dateFormat: "d M, Y",
                          }}
                          onChange={(selectedDates, dateStr, instance) => {
                            setValue("ClosingDate", dateStr)
                          }}
                          required
                        />
                        {errors?.ClosingDate?.message ? (
                          <FormFeedback type="invalid" className="d-block">
                            {errors?.ClosingDate?.message}
                          </FormFeedback>
                        ) : null}
                      </>
                    )}
                  />
                </div>
                <div className="mb-3">
                  <Label>Description</Label>
                  <Controller
                    name="Description"
                    control={control}
                    render={({ field }) => (
                      <>
                        <textarea
                          {...field}
                          rows={3}
                          className="form-control mb-3"
                          id={`Description`}
                          required
                          onInvalid={!!errors.Description}
                        />
                        {errors?.Description?.message ? (
                          <FormFeedback type="invalid" className="d-block">
                            {errors?.Description?.message}
                          </FormFeedback>
                        ) : null}
                      </>
                    )}
                  />
                </div>
              </Col>
            </Row>
          </FormProvider>
        </ModalBody>
        <ModalFooter>
          <div className="d-flex flex-wrap gap-2">
            <button
              hidden={!onEdit}
              type="button"
              className="btn btn btn-danger"
              onClick={() => onDeleteClick()}
            >
              Delete
            </button>
            <button
              type="button"
              className="btn btn btn-primary"
              onClick={() => onSaveClick()}
            >
              Save
            </button>
            <button
              type="button"
              className="btn btn btn-secondary"
              onClick={onCloseClick}
            >
              Cancel
            </button>
          </div>
        </ModalFooter>
      </Modal>
    </>
  )
}

ClosingModal.propTypes = {
  onCloseClick: PropTypes.func,
  show: PropTypes.any,
}

export default ClosingModal
